export default {
  billingCentreResults(currentState, value) {
    const state = currentState;
    state.billingCentreResults = Object.assign([], value);
  },
};
